var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabels11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_220",
    "data-name": "Grupo 220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.657,
    height: 89.354,
    viewBox: "0 0 65.657 89.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M7.1,0H58.559a6.871,6.871,0,0,1,7.1,6.619V82.735a6.871,6.871,0,0,1-7.1,6.619H7.1A6.871,6.871,0,0,1,0,82.735V6.619A6.871,6.871,0,0,1,7.1,0Z",
    fill: "#2c3d71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130",
    "data-name": "Rect\\xE1ngulo 130",
    width: 52.348,
    height: 75.417,
    transform: "translate(7 7)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels11);
export default __webpack_public_path__ + "static/media/labels1-1.81d5c16d.svg";
export { ForwardRef as ReactComponent };